// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"7fc0f5a8","979":"7fc0f5a8"}[chunkId] + ".chunk.css";
};